module.exports = __webpack_public_path__ + "static/media/crmMiddleBarNoData.066314d4.svg";